import React from 'react';

import { NumberInput as MantineNumberInput } from '@mantine/core';

import { getTextFieldErrorComponent } from '@root/features/form/components/TextInput/TextInput';

import { type Component, type ComponentDisplayName } from '@root/lib/types/components';

import { type NumberInputProps } from './NumberInput.types';

/**
 * NumberInput component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const NumberInput: Component<NumberInputProps> = ({ error, ...rest }) => (
	<MantineNumberInput error={getTextFieldErrorComponent(error)} {...rest} />
);

/**
 * NumberInput component display name
 * @type {ComponentDisplayName}
 */
NumberInput.displayName = 'component/NumberInput';
